module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Apply Credit Card Rewards',
        available: 'available',
        selectThree: 'Select up to three',
        creditCardReward: `<b>$${vars[0]}</b> Credit Card Reward`,
        expiry: `Exp ${vars[0]}`,
        orderSubTotal: 'Order Subtotal',
        apply: 'Apply',
        applied: 'Applied',
        remove: 'Remove',
        ccMessage: '*With your Sephora Credit card or Sephora Visa. Exclusions apply',
        clickHere: 'click here for details',
        done: 'Done'
    };

    return resources[label];
};
